import React, { useState } from 'react'
import { NoRecords, PageLoader } from '../../lib/loader'
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { useDeleteCms } from './api/cmsapi';
import { Edit, Trash } from 'lucide-react';
import Cms from './tabs/cms';
import { Modal, ModalBody } from 'reactstrap';
import moment from 'moment';
import useConfirm from '../../hooks/useConfirm';
import { useGetHomeCms } from '../Homepage-Management/api/homepageApi';


function CMSManagement() {

    const [editdata, setEditdata] = useState();
    const { data: getCms, isLoading } = useGetHomeCms()

    const filteredCms = getCms?.data?.cms?.filter(item => item?.title === "Privacy" || item?.title === "Terms" || item?.title === 'FAQ');

    const deleteCMS = useDeleteCms();
    const [Dialog, confirmDelete] = useConfirm()

    const [isedit, setIsedit] = useState(false)
    const toggleEdit = () => {
        setIsedit(!isedit)
    }

    const handleEdit = (item) => {
        setEditdata(item);
        toggleEdit()
    }


    const deleteCms = async (item) => {
        const isConfirmed = await confirmDelete()
        if (isConfirmed) {
            await deleteCMS.mutateAsync(item);
        }
    }

    let content;

    if (filteredCms?.length > 0) {
        content = (

            <div style={{ minHeight: "60vh" }}>
                <div className='table-responsive'>
                    <Table sx={{ minWidth: 650 }} aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell style={{ maxWidth: "60px" }} align='center'>
                                    S.NO
                                </TableCell>
                                <TableCell>Title</TableCell>
                                <TableCell>Date & Time </TableCell>
                                <TableCell align='center'>Action</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {filteredCms?.map((row, i) => (
                                <TableRow key={row.id || i}>
                                    <TableCell align='center'>{(i + 1)}</TableCell>
                                    <TableCell>{row.heading}</TableCell>

                                    <TableCell>{moment(row.updatedAt).format("DD/MM/YYYY | hh:mm A")}</TableCell>
                                    <TableCell align='center'>
                                        <div className='d-flex justify-content-center'>
                                            <Edit className="mx-3" size={20} type='button' onClick={() => handleEdit(row)} />
                                            {row.title === "Simple. Safe. Secure" && <Trash className="mx-3" size={20} onClick={() => deleteCms(row)} type='button' />}
                                        </div>
                                    </TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                    </Table>
                </div>
            </div>

        );
    } else {
        content = <NoRecords />;
    }


    return (

        <section>
            <h4>Content Management</h4>
            <br />
            <br />
            <div className="ad_pg_bx bg-white p-3">
                {isLoading ?
                    <PageLoader />
                    :
                    content
                }
            </div>
            <Dialog />

            <Modal isOpen={isedit} toggle={toggleEdit} centered>
                <div className="modal-header">
                    <h1 className="modal-title fs-10">CMS Management</h1>
                    <button type="button" className="btn-close" onClick={toggleEdit} aria-label="Close">
                        <img src={require('../../assets/images/icons/close-circle.svg').default} alt="close-circle" />
                    </button>
                </div>
                <ModalBody>
                    <Cms editData={editdata} toggleEdit={toggleEdit} />
                </ModalBody>
            </Modal>
        </section>
    )
}


export default CMSManagement